import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { isDefined, getLocalizedAttrValue } from '@grandvisionhq/utils';

function getActiveVariant(product, sku) {
    if (!sku) {
        return product.masterVariant;
    }
    if (product.masterVariant.sku === sku) {
        return product.masterVariant;
    }
    return product.variants.find((variant)=>variant.sku === sku
    ) || product.masterVariant;
}
function getPrice(variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length || !variant.prices[0]) {
        return undefined;
    }
    const price = variant.prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: price.value.currencyCode
        };
    }
    const discounted = price.discounted;
    return {
        currency: price.value.currencyCode,
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount
    };
}
const isValidSupplement = (supplement)=>{
    return isDefined(supplement.centAmount) && supplement.centAmount > 0;
};
function getMinimumSupplement(variant) {
    var ref, ref1;
    if (!Array.isArray(variant.prices) || !variant.prices.length || !variant.prices[0]) {
        return undefined;
    }
    const price = variant.prices[0];
    if (!((ref = price.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.minimumSupplement)) {
        return undefined;
    }
    const { minimumSupplement , minimumSupplementDiscounted  } = price.custom.fields;
    if (!isValidSupplement(minimumSupplement)) {
        return undefined;
    }
    if (!minimumSupplementDiscounted) {
        return {
            originalPrice: minimumSupplement.centAmount,
            currency: minimumSupplement.currencyCode
        };
    }
    return {
        originalPrice: minimumSupplement.centAmount,
        currency: minimumSupplement.currencyCode,
        discountedPrice: isValidSupplement(minimumSupplementDiscounted) ? minimumSupplementDiscounted.centAmount : undefined
    };
}
function getAvailableQuantity(availability) {
    const channels = availability && availability.channels || {};
    const quantity = Object.entries(channels).map(([_, channel])=>channel && channel.availableQuantity || 0
    ).reduce((acc, val)=>acc + val
    , 0);
    return quantity;
}
function getProductModelName(variant, locale, productType) {
    if (CommerceToolsApi.isLenses(productType)) {
        return getLocalizedAttrValue(variant, 'materialType', locale);
    }
    return variant.name || '';
}

export { getActiveVariant, getAvailableQuantity, getMinimumSupplement, getPrice, getProductModelName };
//# sourceMappingURL=helpers.js.map
